import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { chekYears } from 'pages/Birthday';

import PageTitle from 'components/PageTitle';
import Button from 'components/Button';
import Input from 'components/Input';
// API, TELEPHONE_CODE
import { URLS } from 'config';
// getStorage
import { setStorage } from 'utilz';
import './styles.scss';
import containerActions from './actions';

class NamePage extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      nameInputError: false,
      nameInputOverlong: false
    };
  }
  componentDidMount() {
    let nextUrl = URLS.BIRTHDAY;
    let lastRoute = true;
    const isRedirect = Object.keys(this.props.match.params)
      .map(key => this.props.match.params[key])
      .filter(keyValue => keyValue !== undefined);

    if (isRedirect.length) {
      if (this.props.match.params.name && this.props.match.params.name !== '-') {
        this.props.nameChange(this.props.match.params.name);
        setStorage({
          name: {
            name: this.props.match.params.name
          }
        });
      }

      if (this.props.match.params.birthday) {
        if (this.props.match.params.birthday !== '-') {
          const date = new Date(this.props.match.params.birthday);
          const month = date.getMonth() + 1;
          const birthday = [
            ...`${date.getDate()}`.split(''),
            ...`${month.length >= 2 ? '' : '0'}${month}`.split(''),
            ...`${date.getFullYear()}`.split('')
          ];

          // eslint-disable-next-line
          const isValid = chekYears(birthday) === NaN && chekYears(birthday) >= 18 && chekYears(birthday) <= 75;
          lastRoute = isValid;
          setStorage({
            birthday: {
              birthday
            }
          });
          this.props.birthdayChangeHandl(birthday);

          if (isValid) {
            nextUrl = URLS.GENDER;
          }
        } else if (this.props.match.params.birthday === '-') {
          nextUrl = URLS.BIRTHDAY;
          lastRoute = false;
        }
      }

      if (this.props.match.params.gender !== undefined && this.props.match.params.gender !== '-') {
        setStorage({
          gender: {
            gender: this.props.match.params.gender
          }
        });

        if (lastRoute) {
          nextUrl = URLS.WORKING;
        }
      }

      this.props.history.push(
        nextUrl,
        {
          goToGender: this.props.match.params.gender === undefined
          || this.props.match.params.gender === '-'
        }
      );
    }
  }

  componentWillUnmount() {
    // console.log(this.props.name);
    if (this.props.name !== '') {
      setStorage({
        name: {
          name: this.props.name
        }
      });
    }
  }

  inputChangeHandl = (e) => {
    this.props.nameChange(e.target.value);
    this.setState({
      nameInputError: false,
      nameInputOverlong: false
    });
  }

  sendNameHandl = isFacebook => (e) => {
    const patt = new RegExp(/^\w+\s+[\w-.]+$|^\w+\s+[\w-.]+\s+[\w-.]+$/g);

    e.preventDefault();
    if (patt.test(this.props.name.trim()) && this.props.name.trim().length < 100) {
      this.props.nameChange(this.props.name.trim());
      this.props.sendName(() => {
        this.props.history.push(URLS.BIRTHDAY);
      }, isFacebook);
    } else if (this.props.name.trim().length >= 100) {
      this.setState({
        nameInputOverlong: true
      });
    } else {
      this.setState({
        nameInputError: true
      });
    }
  }

  render() {
    // const number = this.props.phone && this.props.phone !== ''
    //   ? this.props.phone : getStorage().phone && getStorage().phone.phone;
    return (
      <div className="page-name -not-full">
        <PageTitle>
          What is your full name ?
        </PageTitle>
        <div className="name-input">
          <Input
            placeholder="Full name"
            value={this.props.name}
            changeHandl={this.inputChangeHandl}
            isError={this.state.nameInputError}
          />
          <p className="error-text">
            { this.state.nameInputError ? 'Please provide full name' : ''}
            { this.state.nameInputOverlong ? 'Name is too long' : ''}
          </p>

        </div>
        <Button
          onClick={this.sendNameHandl(false)}
          disabled={this.props.name === ''}
        >
          Next
        </Button>
        {/* <p className="or">
          or continue with social networks
        </p>
        <a
          href={`${API.FACEBOOK}/${TELEPHONE_CODE}${number}`}
          className="fb-button"
        >
          Continue with Facebook
        </a> */}
      </div>
    );
  }
}
// href={`${API.FACEBOOK}/${TELEPHONE_CODE}${number}`}

NamePage.propTypes = {
  name: PropTypes.string.isRequired,
  nameChange: PropTypes.func.isRequired,
  sendName: PropTypes.func.isRequired,
  // eslint-disable-next-line
  history: PropTypes.object.isRequired,
  // eslint-disable-next-line
  match: PropTypes.object.isRequired,
  // eslint-disable-next-line
  phone: PropTypes.string,
  birthdayChangeHandl: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  name: state.name.name,
  phone: state.phone.phone
});

export default connect(mapStateToProps, containerActions)(NamePage);



// WEBPACK FOOTER //
// ./src/pages/Name/index.js